import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSmartContract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M9 1.8a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1H9ZM15.5 9.55a.75.75 0 0 0 0-1.5h-7a.75.75 0 0 0 0 1.5h7ZM16.25 12.8a.75.75 0 0 1-.75.75h-7a.75.75 0 1 1 0-1.5h7a.75.75 0 0 1 .75.75ZM14.778 22.084c-.583.606-2.134.877-2.134.877s.322-1.672.845-2.215c.443-.46 1.086-.545 1.45-.168.362.377.282 1.046-.16 1.506ZM19.552 16.576a.581.581 0 0 0 .576-.586.581.581 0 0 0-.576-.586.581.581 0 0 0-.576.586c0 .324.258.586.576.586Z"
    />
    <path
      fill="#F7A600"
      d="m22.692 13.466-.128-.51-.503-.133c-.904-.242-2.09-.03-3.215.457a9.175 9.175 0 0 0-3.108 2.228c-.909.065-1.668.468-2.372 1.185l-.758.77 1.957 1.34c-.035.603.24 1.213.65 1.63.407.415 1 .694 1.584.667l1.32 2.021.761-.775c.721-.733 1.123-1.51 1.178-2.45a9.47 9.47 0 0 0 2.182-3.16c.478-1.144.69-2.348.452-3.27Zm-3.266 1.207c.753-.325 1.41-.45 1.877-.437.012.475-.11 1.14-.431 1.906a7.94 7.94 0 0 1-2.04 2.841l-.268.237.012.362c.014.394-.06.74-.27 1.093l-.93-1.426-.597.328c-.003.001-.052.022-.16-.004a.758.758 0 0 1-.352-.21.764.764 0 0 1-.204-.355c-.025-.111-.003-.164 0-.17l.33-.607-1.386-.948c.338-.203.673-.28 1.054-.27l.353.008.229-.273a7.68 7.68 0 0 1 2.783-2.075Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M19.25 5.8c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H6a2.75 2.75 0 0 1-2.75-2.75V5.8A2.75 2.75 0 0 1 6 3.05h12a2.75 2.75 0 0 1 2.75 2.75v5a.75.75 0 1 1-1.5 0v-5Z"
    />
  </svg>
);
export default SvgTwoColorSmartContract;
